import { useRouter } from 'next/navigation';
import { Checkbox, TableCell, TableRow } from '@mui/material';

import { ProcessedName, StyledIdTableCell } from '~/shared';
import { CampaignReport } from '~/types';

export type SponsoredProductsReportCampaignsRowProps = {
  advertiserId: string;
  resume: CampaignReport;
  isSelected: boolean;
  onSelect: (selected: boolean) => void;
};

export function SponsoredProductsReportCampaignsRow({
  resume,
  advertiserId,
  isSelected,
  onSelect,
}: SponsoredProductsReportCampaignsRowProps) {
  const router = useRouter();

  function handleClick() {
    router.push(
      `/patrocinados/relatorios/${advertiserId}/${resume.idCampaign}`
    );
  }

  const getPlatformLabel = ({
    isApp,
    isWeb,
  }: Pick<CampaignReport, 'isApp' | 'isWeb'>) => {
    const appLabel = isApp ? 'App' : '';
    const webLabel = isWeb ? 'Web' : '';

    if (appLabel && webLabel) {
      return `${appLabel}/${webLabel}`;
    }
    if (appLabel || webLabel) {
      return `${appLabel}${webLabel}`;
    }
    return '-';
  };

  return (
    <TableRow
      key={resume.idCampaign}
      sx={{
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        '&:hover': {
          '.MuiTableCell-body': {
            backgroundColor: theme => theme.palette.grey[100],
          },
        },
        '.MuiTableCell-body': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <TableCell align="center" onClick={e => e.stopPropagation()}>
        <Checkbox
          checked={isSelected}
          onChange={e => onSelect(e.target.checked)}
        />
      </TableCell>

      <StyledIdTableCell
        component="th"
        scope="row"
        align="center"
        onClick={handleClick}
      >
        {resume.idCampaign}
      </StyledIdTableCell>
      <TableCell
        component="th"
        scope="row"
        sx={{ position: 'sticky', left: 0 }}
        onClick={handleClick}
      >
        <ProcessedName name={resume.nameCampaign} />
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {getPlatformLabel(resume)}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.impressions ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.clicks ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.ctr ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.cpm ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {resume.cpc ?? '-'}
      </TableCell>
      <TableCell component="th" scope="row" onClick={handleClick}>
        {/* TODO: Implementar dados de vendas quando a API estiver disponível */}
        -
      </TableCell>
    </TableRow>
  );
}
